import { Button } from "devextreme-react";
import React, { useEffect, useState } from "react";

import MissReasonGraph from "./missReason/MissReasonGraph";
import AttainmentGraph from "./attainment/AttainmentGraph";
import { postUserLog } from "../../../actions/common";

const Graph = (props) => {
  const { siteId, tierId, siteDate, moduleName } = props;

  const [graphSelected, setGraphSelected] = useState(0);

  return (
    <section className="page-content">
      <div
        style={{
          display: "flex",
          margin: "5px 0",
        }}
      >
        <Button
          text="Miss Reason"
          onClick={() => {
            setGraphSelected(0);
            postUserLog({
              event: "Pareto",
              data: {
                action: "Miss Reason View Selected",
                module: "Digital Tier",
                section: moduleName,
                siteUId: siteId,
                widget: "OPH TRACKER",
                tierId,
              },
            });
          }}
        />
        <Button
          text="Attainment - Hourly"
          onClick={() => {
            setGraphSelected(1);
            postUserLog({
              event: "Pareto",
              data: {
                action: "Attainment Hourly View Selected",
                module: "Digital Tier",
                section: moduleName,
                siteUId: siteId,
                widget: "OPH TRACKER",
                tierId,
              },
            });
          }}
        />
      </div>

      <div>
        {graphSelected == 0 ? (
          <MissReasonGraph
            siteId={siteId}
            tierId={tierId}
            siteDate={siteDate}
            moduleName={moduleName}
          />
        ) : (
          <AttainmentGraph tierId={tierId} siteDate={siteDate} />
        )}
      </div>
    </section>
  );
};

export default React.memo(Graph);
